import EntitiesRoutes from './entities.routes'
import SettingsRoutes from './settings.routes'
// import EmbeddableRoutes from './embeddable.routes'
import Route from './route'

const routes = [
  ...SettingsRoutes,
  ...EntitiesRoutes,
  // ...EmbeddableRoutes,
  Route('*', {}, 'error')
]

export default routes
